import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux';
import { store } from './store/store';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './AppRouter';
import './main.css'
import { ToastContainer } from 'react-toastify';
import { DotCircleLoader } from './components';

ReactDOM.createRoot(document.getElementById('booking-engine')).render(
    <Provider store={store}>
        <BrowserRouter>
            <AppRouter />
            <ToastContainer
                className={"toast-container"}
            />
            <DotCircleLoader />
        </BrowserRouter>
    </Provider>
);
